import { render } from "./InfoElement.vue?vue&type=template&id=21f5f223&scoped=true"
import script from "./InfoElement.vue?vue&type=script&lang=js"
export * from "./InfoElement.vue?vue&type=script&lang=js"

import "./InfoElement.vue?vue&type=style&index=0&id=21f5f223&scoped=true&lang=css"

import exportComponent from "/Users/matthewnorth/Documents/Projects/ip-address-tracker-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f5f223"]])

export default __exports__